<template>
  <nav>
    <div
      class="alertNotification text-center"
      style="
        position: fixed;
        z-index: 999;
        width: auto;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        left: 0px;
        padding: 0px 15px;
        right: 0;
        top: 64px;
      "
    >
      <v-alert
        v-model="alertValue"
        style="width: auto; max-width: initial"
        :type="alertType"
        dismissible
        transition="slide-y-transition"
        class="rounded-xxl text-left"
      >
        {{ alertMsg }}
      </v-alert>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    alertMsg: {
      type: String,
      default: "",
    },
    alertType: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      alertValue: true,
    };
  },
  watch: {
    //when close is clicked
    alertValue(val) {
      if (!val) {
        this.$emit("reset");
      }
    },
  },
  created() {
    setTimeout(() => {
      this.alertValue = false;
      this.$emit("reset");
   }, 5000);
  },
};
</script>

<style>
.alertNotification button.v-alert__dismissible {
  margin: 0px 0px 0px 8px;
  height: auto;
  width: auto;
}
.alertNotification .v-alert__wrapper {
  align-items: self-start;
}

@media (max-width: 767px) {
  .alertNotification {
    top: 56px !important;
  }
}
</style>